export default __webpack_public_path__ + "static/media/evening_empty.1da8b408.svg";